module.exports = __webpack_public_path__ + "static/media/icon_211.feee941a.svg";